import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { API_URLS } from '../Utils/Constants.js';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import '../Style/Login.css';

const Login = () => {
    const [activeTab, setActiveTab] = useState('user');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [dpi, setDpi] = useState('');
    const [membershipNumber, setMembershipNumber] = useState('');
    const [birthday, setBirthday] = useState('');
    const [error, setError] = useState('');
    const { setToken } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/home');
        }
    }, [navigate]);

    const handleLogin = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const formattedBirthday = birthday ? new Date(birthday).toISOString().split('T')[0] : '';

        const raw = JSON.stringify({
            username,
            password,
            ...(activeTab === 'user' ? { dpi, membership_number: membershipNumber, birthday: formattedBirthday, type: "VOTANTE" } : { type: "ADMIN" })
        });

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
        };

        const url = `${API_URLS.BASE_PATH}/api/login`;

        try {
            const response = await fetch(url, requestOptions);
            const data = await response.json();

            if (data.token != null) {
                setToken(data.token);
                localStorage.setItem('token', data.token);
                navigate('/home');
            }else{
                setError(data.error);
            }

        } catch (error) {
            console.error('Error during login:', error);
            setError('Error connecting to the server');
        }
    };

    const irRegistro = () => {
        navigate('/register');
    };

    return (
        <div className="login-container">
            <div className="login-content">
                <Card className="login-card shadow">
                    <Card.Body>
                        <div className="toggle-tabs">
                            <Button
                                className={`tab-btn ${activeTab === 'user' ? 'active' : ''}`}
                                onClick={() => setActiveTab('user')}
                            >
                                Usuario
                            </Button>
                            <Button
                                className={`tab-btn ${activeTab === 'admin' ? 'active' : ''}`}
                                onClick={() => setActiveTab('admin')}
                            >
                                Administrador
                            </Button>
                        </div>

                        <Form>
                            <Form.Group className="mb-3" controlId="username">
                                <Form.Label>Usuario</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ingresa tu nombre de usuario"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="password">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Contraseña"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Group>

                            {activeTab === 'user' && (
                                <>
                                    <Form.Group className="mb-3" controlId="dpi">
                                        <Form.Label>DPI</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingresa tu DPI"
                                            value={dpi}
                                            onChange={(e) => setDpi(e.target.value)}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="membershipNumber">
                                        <Form.Label>Número de Membresía</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingresa tu número de membresía"
                                            value={membershipNumber}
                                            onChange={(e) => setMembershipNumber(e.target.value)}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="birthday">
                                        <Form.Label>Fecha de Nacimiento</Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Ingresa tu fecha de nacimiento"
                                            value={birthday}
                                            onChange={(e) => setBirthday(e.target.value)}
                                        />
                                    </Form.Group>
                                </>
                            )}

                            {error && <p className="text-danger">{error}</p>}

                            <Button variant="primary" onClick={handleLogin} className="w-100 mb-2">
                                {activeTab === 'admin' ? 'Iniciar sesión como Administrador' : 'Iniciar sesión como Usuario'}
                            </Button>
                        </Form>

                        {activeTab === 'user' && (
                            <Button variant="link" onClick={irRegistro} className="mt-3">
                                ¿No tienes cuenta? Regístrate aquí
                            </Button>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default Login;
